module.exports = __webpack_public_path__ + "react-logo.28e8a90b.png";


//////////////////
// WEBPACK FOOTER
// ./client/components/react-logo.png
// module id = 344
// module chunks = 0